export let region = {
    "YGJY_621000_01": "庆阳市政府采购协议供货项目阳光交易系统",
    "YGJY_621000_02": "庆阳市限额以下工程项目阳光交易系统",
    "YGJY_620000_01": "省级平台政府采购协议供货项目阳光交易系统",
    "YGJY_620000_02": "省级平台限额以下工程项目阳光交易系统",
    "YGJY_620100_01": "兰州市政府采购协议供货项目阳光交易系统",
    "YGJY_620100_02": "兰州市限额以下工程项目阳光交易系统",
    "YGJY_620200_01": "嘉峪关市政府采购协议供货项目阳光交易系统",
    "YGJY_620200_02": "嘉峪关市限额以下工程项目阳光交易系统",
    "YGJY_620300_01": "金昌市政府采购协议供货项目阳光交易系统",
    "YGJY_620300_02": "金昌市限额以下工程项目阳光交易系统",
    "YGJY_620500_01": "天水市政府采购协议供货项目阳光交易系统",
    "YGJY_620500_02": "天水市限额以下工程项目阳光交易系统",
    "YGJY_620600_01": "武威市政府采购协议供货项目阳光交易系统",
    "YGJY_620600_02": "武威市限额以下工程项目阳光交易系统",
    // 展示picc担保机构
    "YGJY_620700_01": "张掖市政府采购协议供货项目阳光交易系统",
    "YGJY_620700_02": "张掖市限额以下工程项目阳光交易系统",
    
    "YGJY_620800_01": "平凉市政府采购协议供货项目阳光交易系统",
    "YGJY_620800_02": "平凉市限额以下工程项目阳光交易系统",
    "YGJY_621200_01": "陇南市政府采购协议供货项目阳光交易系统",
    "YGJY_621200_02": "陇南市限额以下工程项目阳光交易系统",
    "YGJY_623000_01": "甘南州政府采购协议供货项目阳光交易系统",
    "YGJY_623000_02": "甘南州限额以下工程项目阳光交易系统",
    "YGJY_622900_01": "临夏州政府采购协议供货项目阳光交易系统",
    "YGJY_622900_02": "临夏州限额以下工程项目阳光交易系统",
    "YGJY_620200_03": "嘉峪关市政府采购限额以下项目阳光交易系统",
    "YGJY_620200_04": "嘉峪关市政府采购定点采购项目阳光交易系统",
    "YGJY_620000_03": "省级平台政府采购限额以下项目阳光交易系统",
    "YGJY_620000_04": "省级平台政府采购定点采购项目阳光交易系统",
    "YGJY_620300_03": "金昌市政府采购限额以下项目阳光交易系统",
    "YGJY_620300_04": "金昌市政府采购定点采购项目阳光交易系统",
    "YGJY_620500_03": "天水市政府采购限额以下项目阳光交易系统",
    "YGJY_620600_03": "武威市政府采购限额以下项目阳光交易系统",
    "YGJY_620600_04": "武威市政府采购定点采购项目阳光交易系统",
    "YGJY_622900_03": "临夏州政府采购限额以下项目阳光交易系统",
    "YGJY_622900_04": "临夏州政府采购定点采购项目阳光交易系统",
    "YGJY_620800_03": "平凉市政府采购限额以下项目阳光交易系统",
    "YGJY_620800_04": "平凉市政府采购定点采购项目阳光交易系统",
    "YGJY_623000_03": "甘南州政府采购限额以下项目阳光交易系统",
    "YGJY_621200_03": "陇南市政府采购限额以下项目阳光交易系统",
    "YGJY_621000_03": "庆阳市政府采购限额以下项目阳光交易系统",
}